import { useState } from "react";
import styled from "styled-components";
import { Alert, Button, Icon } from "@blueprintjs/core";
import { Tooltip } from "@mantine/core";

type Props = {
  itemId: string;
  onDelete: () => void;
};

const HoverButton = styled(Button)`
  visibility: hidden;
  tr:hover & {
    visibility: visible;
  }
`;

export const DeleteItemCell = ({ itemId, onDelete }: Props) => {
  const [showDeleteWarning, setShowDeleteWarning] = useState<boolean>(false);
  return (
    <>
      <Alert
        className="deleteIntegrationWarning"
        cancelButtonText="Cancel"
        confirmButtonText="Remove"
        icon="trash"
        style={{ width: "400px" }}
        intent="danger"
        isOpen={showDeleteWarning}
        onCancel={() => setShowDeleteWarning(false)}
        onConfirm={() => {
          setShowDeleteWarning(false);
          onDelete();
        }}
      >
        <p>Are you sure you want to remove {itemId}?</p>
      </Alert>
      <Tooltip label="Click to remove from policy" withArrow withinPortal>
        <div>
          <HoverButton minimal onClick={() => setShowDeleteWarning(true)}>
            <Icon icon="cross" />
          </HoverButton>
        </div>
      </Tooltip>
    </>
  );
};
